'use client';
import React from 'react';
import type { FormatTextProps } from '@/utils/text/text';
import { formatText } from '@/utils/text/text';

type RichTextOrderListProps = {
    list?: FormatTextProps[];
};

export const RichTextOrderList: React.FC<RichTextOrderListProps> = ({ list = [] }) => {
    return (
        <ol>
            {list.map((element, index) => (
                // TODO: remove dangerouslySetInnerHTML
                <li key={index} dangerouslySetInnerHTML={{ __html: formatText(element) }} />
            ))}
        </ol>
    );
};
